var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimationpic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1056,
    height: 550,
    viewBox: "0 0 1056 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H528V275H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H528V275H0V0Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H528V275H0V0Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H528V275H0V0Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H528V275H0V0Z",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 275H1055V550H527V275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 275H1055V550H527V275Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 275H1055V550H527V275Z",
    fill: "url(#paint5_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 275H1055V550H527V275Z",
    fill: "url(#paint6_linear)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 275H1055V550H527V275Z",
    fill: "url(#paint7_linear)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275H528V550H0V275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275H528V550H0V275Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275H528V550H0V275Z",
    fill: "url(#paint9_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275H528V550H0V275Z",
    fill: "url(#paint10_linear)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275H528V550H0V275Z",
    fill: "url(#paint11_linear)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 0H1056V275H528V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 0H1056V275H528V0Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 0H1056V275H528V0Z",
    fill: "url(#paint13_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 0H1056V275H528V0Z",
    fill: "url(#paint14_linear)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 0H1056V275H528V0Z",
    fill: "url(#paint15_linear)",
    fillOpacity: 0.45
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.203,
    cy: 202.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.806 199.029L704.366 227.474H655.247L679.806 199.029Z",
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.203,
    cy: 193.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.806,
    cy: 227.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.274 227.186C658.775 230.512 660.725 231.788 664.722 233.507",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.481 226.612C657.473 227.111 658.353 228.022 660.498 230.06M655.068 227.187C656.658 230.022 662.721 231.973 662.912 232.933",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.357 226.145C701.209 229.682 699.398 231.129 695.597 233.204",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.097 225.684C702.157 226.179 701.374 227.166 699.446 229.391M704.558 226.035C703.265 229.002 697.429 231.498 697.337 232.471",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.526 226.267L654.319 227.417",
    stroke: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.459 225.463L704.665 226.612",
    stroke: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.303 226.268L704.907 226.842",
    stroke: "#D0F3D5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 573.203,
    cy: 257.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.806 254.029L598.366 282.474H549.247L573.806 254.029Z",
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 573.203,
    cy: 248.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 573.806,
    cy: 282.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.274 282.186C552.775 285.512 554.725 286.788 558.722 288.507",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.481 281.612C551.473 282.111 552.353 283.022 554.498 285.06M549.068 282.187C550.658 285.022 556.721 286.973 556.912 287.933",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.357 281.146C595.209 284.684 593.398 286.132 589.596 288.208",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.097 280.684C596.157 281.179 595.374 282.166 593.446 284.391M598.558 281.035C597.265 284.002 591.429 286.498 591.337 287.471",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.526 281.267L548.319 282.417",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.459 280.463L598.665 281.612",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.303 281.268L598.907 281.842",
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.203,
    cy: 137.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.806 134.029L624.366 162.474H575.247L599.806 134.029Z",
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.203,
    cy: 128.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 599.806,
    cy: 162.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.274 162.186C578.775 165.512 580.725 166.788 584.722 168.507",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.481 161.612C577.473 162.111 578.353 163.022 580.498 165.06M575.068 162.187C576.658 165.022 582.721 166.973 582.912 167.933",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.357 161.145C621.209 164.682 619.398 166.129 615.597 168.204",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.097 160.684C622.157 161.179 621.374 162.166 619.446 164.391M624.558 161.035C623.265 164.002 617.429 166.498 617.337 167.471",
    stroke: "#72AD7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.526 161.267L574.319 162.417",
    stroke: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.459 160.463L624.665 161.612",
    stroke: "#D0F3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.303 161.268L624.907 161.842",
    stroke: "#D0F3D5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.203,
    cy: 373.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.806 370.029L533.366 398.474H484.247L508.806 370.029Z",
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.203,
    cy: 364.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.806,
    cy: 398.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.274 398.186C487.775 401.512 489.725 402.787 493.722 404.507",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.481 397.612C486.473 398.111 487.353 399.022 489.498 401.06M484.068 398.187C485.658 401.022 491.721 402.973 491.912 403.933",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.357 397.145C530.209 400.682 528.398 402.129 524.596 404.204",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.097 396.684C531.156 397.179 530.374 398.166 528.446 400.391M533.558 397.035C532.264 400.002 526.429 402.498 526.337 403.471",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.49 397.267L483.283 398.417",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.422 396.463L533.629 397.612",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.267 397.268L533.871 397.842",
    stroke: "#FFD8D8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.203,
    cy: 450.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.806 447.029L438.366 475.474H389.247L413.806 447.029Z",
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.203,
    cy: 441.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413.806,
    cy: 475.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.274 475.186C392.775 478.512 394.725 479.788 398.722 481.507",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.481 474.612C391.473 475.111 392.353 476.022 394.498 478.06M389.068 475.187C390.658 478.022 396.721 479.973 396.912 480.933",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.357 474.145C435.209 477.682 433.398 479.129 429.596 481.204",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.097 473.684C436.157 474.179 435.374 475.166 433.446 477.391M438.558 474.035C437.265 477.002 431.429 479.498 431.337 480.471",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49 474.267L388.283 475.417",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.422 473.463L438.629 474.612",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.267 474.268L438.871 474.842",
    stroke: "#FFD8D8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.203,
    cy: 345.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.806 342.029L382.366 370.474H333.247L357.806 342.029Z",
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.203,
    cy: 336.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.806,
    cy: 370.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.274 370.186C336.775 373.512 338.725 374.788 342.722 376.507",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.481 369.612C335.473 370.111 336.353 371.022 338.498 373.06M333.068 370.187C334.658 373.022 340.721 374.973 340.912 375.933",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.357 369.145C379.209 372.682 377.398 374.129 373.596 376.204",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.097 368.684C380.157 369.179 379.374 370.166 377.446 372.391M382.558 369.035C381.265 372.002 375.429 374.498 375.337 375.471",
    stroke: "#D25454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.49 369.267L332.283 370.417",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.423 368.463L382.629 369.612",
    stroke: "#FFD8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.267 369.268L382.871 369.842",
    stroke: "#FFD8D8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.203,
    cy: 312.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.806 309.029L750.366 337.474H701.247L725.806 309.029Z",
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.203,
    cy: 303.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.806,
    cy: 337.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.274 337.186C704.775 340.512 706.725 341.788 710.722 343.507",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.481 336.612C703.473 337.111 704.353 338.022 706.498 340.06M701.068 337.187C702.658 340.022 708.721 341.973 708.912 342.933",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.357 336.146C747.209 339.684 745.398 341.132 741.596 343.208",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.097 335.684C748.157 336.179 747.374 337.166 745.446 339.391M750.558 336.035C749.265 339.002 743.429 341.498 743.337 342.471",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.49 336.267L700.283 337.417",
    stroke: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.422 335.463L750.629 336.612",
    stroke: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.267 336.268L750.871 336.842",
    stroke: "#D8F1FF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 633.203,
    cy: 463.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.806 460.029L658.366 488.474H609.247L633.806 460.029Z",
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 633.203,
    cy: 454.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 633.806,
    cy: 488.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.274 488.186C612.775 491.512 614.725 492.787 618.722 494.507",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.481 487.612C611.473 488.111 612.353 489.022 614.498 491.06M609.068 488.187C610.658 491.022 616.721 492.973 616.912 493.933",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.357 487.145C655.209 490.682 653.398 492.129 649.597 494.204",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.097 486.684C656.157 487.179 655.374 488.166 653.446 490.391M658.558 487.035C657.265 490.002 651.429 492.498 651.337 493.471",
    stroke: "#44A7DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.49 487.267L608.283 488.417",
    stroke: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.422 486.463L658.629 487.612",
    stroke: "#D8F1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.267 487.268L658.871 487.842",
    stroke: "#D8F1FF"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.203,
    cy: 368.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.806 365.029L632.366 393.474H583.247L607.806 365.029Z",
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.203,
    cy: 359.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#44A7DE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.806,
    cy: 393.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#44A7DE"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.203,
    cy: 273.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.806 270.029L500.366 298.474H451.247L475.806 270.029Z",
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.203,
    cy: 264.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.806,
    cy: 298.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.274 298.186C454.775 301.512 456.725 302.788 460.722 304.507",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.481 297.612C453.473 298.111 454.352 299.022 456.498 301.06M451.068 298.187C452.658 301.022 458.721 302.973 458.912 303.933",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.357 297.145C497.209 300.682 495.398 302.129 491.596 304.204",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.097 296.684C498.156 297.179 497.374 298.166 495.446 300.391M500.558 297.035C499.264 300.002 493.429 302.498 493.337 303.471",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.49 297.267L450.283 298.417",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.422 296.463L500.629 297.612",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.267 297.268L500.871 297.842",
    stroke: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.203,
    cy: 116.478,
    rx: 36.2028,
    ry: 34.478,
    fill: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.806 113.029L467.366 141.474H418.247L442.806 113.029Z",
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.203,
    cy: 107.285,
    rx: 13.2744,
    ry: 12.6419,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.806,
    cy: 141.762,
    rx: 21.1183,
    ry: 9.19413,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.274 141.186C421.775 144.512 423.725 145.787 427.722 147.507",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.481 140.612C420.473 141.111 421.353 142.022 423.498 144.06M418.068 141.187C419.658 144.022 425.721 145.973 425.912 146.933",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.357 140.145C464.209 143.682 462.398 145.129 458.597 147.204",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.097 139.684C465.157 140.179 464.374 141.166 462.446 143.391M467.558 140.035C466.265 143.002 460.429 145.498 460.337 146.471",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.49 140.267L417.283 141.416",
    stroke: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.423 139.463L467.629 140.612",
    stroke: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.267 140.268L467.871 140.842",
    stroke: "#FFEBC5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 356,
    cy: 222,
    rx: 30,
    ry: 29.9997,
    fill: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.5 218.999L376.852 243.749H336.148L356.5 218.999Z",
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356,
    cy: 214,
    rx: 11,
    ry: 10.9999,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.5,
    cy: 244,
    rx: 17.5,
    ry: 7.99992,
    fill: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 243.499C339.072 246.392 340.688 247.502 344 248.999",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 242.999C337.993 243.433 338.722 244.226 340.5 245.999M336 243.499C337.318 245.966 342.342 247.664 342.5 248.499",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.016 242.592C374.236 245.67 372.735 246.929 369.585 248.735",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.972 242.191C375.021 242.622 374.372 243.481 372.775 245.417M377.011 242.497C375.939 245.078 371.103 247.251 371.027 248.097",
    stroke: "#FFBC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35 242.699L335.35 243.699",
    stroke: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.07 241.999L377.07 242.999",
    stroke: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77 242.699L377.27 243.199",
    stroke: "#FFEBC5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 138,
    height: 148,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.168 96.8C90.043 96.55 89.9414 96.1047 89.8633 95.4641C88.8555 96.511 87.6524 97.0344 86.2539 97.0344C85.0039 97.0344 83.9766 96.6829 83.1719 95.9797C82.375 95.2688 81.9766 94.3704 81.9766 93.2844C81.9766 91.9641 82.4766 90.9407 83.4766 90.2141C84.4844 89.4797 85.8985 89.1125 87.7188 89.1125H89.8281V88.1165C89.8281 87.3586 89.6016 86.7571 89.1485 86.3118C88.6953 85.8586 88.0274 85.6321 87.1446 85.6321C86.3711 85.6321 85.7227 85.8274 85.1992 86.218C84.6758 86.6086 84.4141 87.0813 84.4141 87.636H82.2344C82.2344 87.0032 82.4571 86.3938 82.9024 85.8079C83.3555 85.2141 83.9649 84.7454 84.7305 84.4016C85.5039 84.0579 86.3516 83.886 87.2735 83.886C88.7344 83.886 89.8789 84.2532 90.7071 84.9875C91.5352 85.7141 91.9649 86.718 91.9961 87.9993V93.8352C91.9961 94.9993 92.1446 95.925 92.4414 96.6125V96.8H90.168ZM86.5703 95.1477C87.25 95.1477 87.8946 94.9719 88.5039 94.6204C89.1133 94.2688 89.5547 93.8118 89.8281 93.2493V90.6477H88.1289C85.4727 90.6477 84.1446 91.425 84.1446 92.9797C84.1446 93.6594 84.3711 94.1907 84.8242 94.5735C85.2774 94.9563 85.8594 95.1477 86.5703 95.1477ZM94.8672 90.3547C94.8672 88.4094 95.3281 86.8469 96.25 85.6672C97.1719 84.4797 98.3789 83.886 99.8711 83.886C101.355 83.886 102.531 84.3938 103.398 85.4094V78.8H105.566V96.8H103.574L103.469 95.4407C102.602 96.5032 101.395 97.0344 99.8477 97.0344C98.3789 97.0344 97.1797 96.4329 96.25 95.2297C95.3281 94.0266 94.8672 92.4563 94.8672 90.5188V90.3547ZM97.0352 90.6008C97.0352 92.0383 97.3321 93.1633 97.9258 93.9758C98.5196 94.7883 99.3399 95.1946 100.387 95.1946C101.762 95.1946 102.766 94.5774 103.398 93.343V87.5188C102.75 86.3235 101.754 85.7258 100.41 85.7258C99.3477 85.7258 98.5196 86.136 97.9258 86.9563C97.3321 87.7766 97.0352 88.9915 97.0352 90.6008ZM66.1563 109.05V112.12H68.5235V113.796H66.1563V121.659C66.1563 122.167 66.2617 122.55 66.4727 122.808C66.6836 123.058 67.043 123.183 67.5508 123.183C67.8008 123.183 68.1446 123.136 68.5821 123.042V124.8C68.0117 124.956 67.4571 125.034 66.918 125.034C65.9492 125.034 65.2188 124.741 64.7266 124.156C64.2344 123.57 63.9883 122.738 63.9883 121.659V113.796H61.6797V112.12H63.9883V109.05H66.1563ZM75.2149 121.624L78.168 112.12H80.4883L75.3906 126.757C74.6016 128.866 73.3477 129.921 71.6289 129.921L71.2188 129.886L70.4102 129.734V127.976L70.9961 128.023C71.7305 128.023 72.3008 127.874 72.7071 127.577C73.1211 127.281 73.461 126.738 73.7266 125.948L74.2071 124.659L69.6836 112.12H72.0508L75.2149 121.624ZM93.1446 118.601C93.1446 120.531 92.7031 122.085 91.8203 123.265C90.9375 124.445 89.7422 125.034 88.2344 125.034C86.6953 125.034 85.4844 124.546 84.6016 123.57V129.675H82.4336V112.12H84.4141L84.5196 113.527C85.4024 112.433 86.6289 111.886 88.1992 111.886C89.7227 111.886 90.9258 112.46 91.8086 113.609C92.6992 114.757 93.1446 116.355 93.1446 118.402V118.601ZM90.9766 118.355C90.9766 116.925 90.6719 115.796 90.0625 114.968C89.4531 114.14 88.6172 113.726 87.5547 113.726C86.2422 113.726 85.2578 114.308 84.6016 115.472V121.531C85.25 122.687 86.2422 123.265 87.5781 123.265C88.6172 123.265 89.4414 122.855 90.0508 122.034C90.668 121.206 90.9766 119.98 90.9766 118.355ZM101.172 125.034C99.4531 125.034 98.0547 124.472 96.9766 123.347C95.8985 122.214 95.3594 120.702 95.3594 118.812V118.413C95.3594 117.156 95.5977 116.034 96.0742 115.05C96.5586 114.058 97.2305 113.284 98.0899 112.73C98.9571 112.167 99.8946 111.886 100.902 111.886C102.551 111.886 103.832 112.429 104.746 113.515C105.66 114.601 106.117 116.156 106.117 118.179V119.081H97.5274C97.5586 120.331 97.9219 121.343 98.6172 122.116C99.3203 122.882 100.211 123.265 101.289 123.265C102.055 123.265 102.703 123.109 103.234 122.796C103.766 122.484 104.23 122.07 104.629 121.554L105.953 122.585C104.891 124.218 103.297 125.034 101.172 125.034ZM100.902 113.667C100.027 113.667 99.293 113.988 98.6992 114.628C98.1055 115.261 97.7383 116.152 97.5977 117.3H103.949V117.136C103.887 116.034 103.59 115.183 103.059 114.581C102.527 113.972 101.809 113.667 100.902 113.667ZM121.492 124.8H119.313V110.351L114.941 111.956V109.988L121.152 107.656H121.492V124.8Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 378,
    width: 138,
    height: 148,
    rx: 10,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M957.168 445.8C957.043 445.55 956.941 445.105 956.863 444.464C955.855 445.511 954.652 446.034 953.254 446.034C952.004 446.034 950.977 445.683 950.172 444.98C949.375 444.269 948.977 443.37 948.977 442.284C948.977 440.964 949.477 439.941 950.477 439.214C951.484 438.48 952.898 438.112 954.719 438.112H956.828V437.116C956.828 436.359 956.602 435.757 956.148 435.312C955.695 434.859 955.027 434.632 954.145 434.632C953.371 434.632 952.723 434.827 952.199 435.218C951.676 435.609 951.414 436.081 951.414 436.636H949.234C949.234 436.003 949.457 435.394 949.902 434.808C950.355 434.214 950.965 433.745 951.73 433.402C952.504 433.058 953.352 432.886 954.273 432.886C955.734 432.886 956.879 433.253 957.707 433.987C958.535 434.714 958.965 435.718 958.996 436.999V442.835C958.996 443.999 959.145 444.925 959.441 445.612V445.8H957.168ZM953.57 444.148C954.25 444.148 954.895 443.972 955.504 443.62C956.113 443.269 956.555 442.812 956.828 442.249V439.648H955.129C952.473 439.648 951.145 440.425 951.145 441.98C951.145 442.659 951.371 443.191 951.824 443.573C952.277 443.956 952.859 444.148 953.57 444.148ZM961.867 439.355C961.867 437.409 962.328 435.847 963.25 434.667C964.172 433.48 965.379 432.886 966.871 432.886C968.355 432.886 969.531 433.394 970.398 434.409V427.8H972.566V445.8H970.574L970.469 444.441C969.602 445.503 968.395 446.034 966.848 446.034C965.379 446.034 964.18 445.433 963.25 444.23C962.328 443.027 961.867 441.456 961.867 439.519V439.355ZM964.035 439.601C964.035 441.038 964.332 442.163 964.926 442.976C965.52 443.788 966.34 444.195 967.387 444.195C968.762 444.195 969.766 443.577 970.398 442.343V436.519C969.75 435.323 968.754 434.726 967.41 434.726C966.348 434.726 965.52 435.136 964.926 435.956C964.332 436.777 964.035 437.991 964.035 439.601ZM933.156 458.05V461.12H935.523V462.796H933.156V470.659C933.156 471.167 933.262 471.55 933.473 471.808C933.684 472.058 934.043 472.183 934.551 472.183C934.801 472.183 935.145 472.136 935.582 472.042V473.8C935.012 473.956 934.457 474.034 933.918 474.034C932.949 474.034 932.219 473.741 931.727 473.155C931.234 472.57 930.988 471.737 930.988 470.659V462.796H928.68V461.12H930.988V458.05H933.156ZM942.215 470.624L945.168 461.12H947.488L942.391 475.757C941.602 477.866 940.348 478.921 938.629 478.921L938.219 478.886L937.41 478.734V476.976L937.996 477.023C938.73 477.023 939.301 476.874 939.707 476.577C940.121 476.28 940.461 475.737 940.727 474.948L941.207 473.659L936.684 461.12H939.051L942.215 470.624ZM960.145 467.601C960.145 469.53 959.703 471.085 958.82 472.265C957.938 473.445 956.742 474.034 955.234 474.034C953.695 474.034 952.484 473.546 951.602 472.57V478.675H949.434V461.12H951.414L951.52 462.527C952.402 461.433 953.629 460.886 955.199 460.886C956.723 460.886 957.926 461.46 958.809 462.609C959.699 463.757 960.145 465.355 960.145 467.402V467.601ZM957.977 467.355C957.977 465.925 957.672 464.796 957.063 463.968C956.453 463.14 955.617 462.726 954.555 462.726C953.242 462.726 952.258 463.308 951.602 464.472V470.53C952.25 471.687 953.242 472.265 954.578 472.265C955.617 472.265 956.441 471.855 957.051 471.034C957.668 470.206 957.977 468.98 957.977 467.355ZM968.172 474.034C966.453 474.034 965.055 473.472 963.977 472.347C962.898 471.214 962.359 469.702 962.359 467.812V467.413C962.359 466.155 962.598 465.034 963.074 464.05C963.559 463.058 964.23 462.284 965.09 461.73C965.957 461.167 966.895 460.886 967.902 460.886C969.551 460.886 970.832 461.429 971.746 462.515C972.66 463.601 973.117 465.155 973.117 467.179V468.081H964.527C964.559 469.331 964.922 470.343 965.617 471.116C966.32 471.882 967.211 472.265 968.289 472.265C969.055 472.265 969.703 472.109 970.234 471.796C970.766 471.484 971.23 471.07 971.629 470.554L972.953 471.585C971.891 473.218 970.297 474.034 968.172 474.034ZM967.902 462.667C967.027 462.667 966.293 462.987 965.699 463.628C965.105 464.261 964.738 465.152 964.598 466.3H970.949V466.136C970.887 465.034 970.59 464.183 970.059 463.581C969.527 462.972 968.809 462.667 967.902 462.667ZM990.52 468.07H992.887V469.839H990.52V473.8H988.34V469.839H980.57V468.562L988.211 456.737H990.52V468.07ZM983.031 468.07H988.34V459.702L988.082 460.171L983.031 468.07Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 29,
    width: 138,
    height: 148,
    rx: 10,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M957.168 96.8C957.043 96.55 956.941 96.1047 956.863 95.4641C955.855 96.511 954.652 97.0344 953.254 97.0344C952.004 97.0344 950.977 96.6829 950.172 95.9797C949.375 95.2688 948.977 94.3704 948.977 93.2844C948.977 91.9641 949.477 90.9407 950.477 90.2141C951.484 89.4797 952.898 89.1125 954.719 89.1125H956.828V88.1165C956.828 87.3586 956.602 86.7571 956.148 86.3118C955.695 85.8586 955.027 85.6321 954.145 85.6321C953.371 85.6321 952.723 85.8274 952.199 86.218C951.676 86.6086 951.414 87.0813 951.414 87.636H949.234C949.234 87.0032 949.457 86.3938 949.902 85.8079C950.355 85.2141 950.965 84.7454 951.73 84.4016C952.504 84.0579 953.352 83.886 954.273 83.886C955.734 83.886 956.879 84.2532 957.707 84.9875C958.535 85.7141 958.965 86.718 958.996 87.9993V93.8352C958.996 94.9993 959.145 95.925 959.441 96.6125V96.8H957.168ZM953.57 95.1477C954.25 95.1477 954.895 94.9719 955.504 94.6204C956.113 94.2688 956.555 93.8118 956.828 93.2493V90.6477H955.129C952.473 90.6477 951.145 91.425 951.145 92.9797C951.145 93.6594 951.371 94.1907 951.824 94.5735C952.277 94.9563 952.859 95.1477 953.57 95.1477ZM961.867 90.3547C961.867 88.4094 962.328 86.8469 963.25 85.6672C964.172 84.4797 965.379 83.886 966.871 83.886C968.355 83.886 969.531 84.3938 970.398 85.4094V78.8H972.566V96.8H970.574L970.469 95.4407C969.602 96.5032 968.395 97.0344 966.848 97.0344C965.379 97.0344 964.18 96.4329 963.25 95.2297C962.328 94.0266 961.867 92.4563 961.867 90.5188V90.3547ZM964.035 90.6008C964.035 92.0383 964.332 93.1633 964.926 93.9758C965.52 94.7883 966.34 95.1946 967.387 95.1946C968.762 95.1946 969.766 94.5774 970.398 93.343V87.5188C969.75 86.3235 968.754 85.7258 967.41 85.7258C966.348 85.7258 965.52 86.136 964.926 86.9563C964.332 87.7766 964.035 88.9915 964.035 90.6008ZM933.156 109.05V112.12H935.523V113.796H933.156V121.659C933.156 122.167 933.262 122.55 933.473 122.808C933.684 123.058 934.043 123.183 934.551 123.183C934.801 123.183 935.145 123.136 935.582 123.042V124.8C935.012 124.956 934.457 125.034 933.918 125.034C932.949 125.034 932.219 124.741 931.727 124.156C931.234 123.57 930.988 122.738 930.988 121.659V113.796H928.68V112.12H930.988V109.05H933.156ZM942.215 121.624L945.168 112.12H947.488L942.391 126.757C941.602 128.866 940.348 129.921 938.629 129.921L938.219 129.886L937.41 129.734V127.976L937.996 128.023C938.73 128.023 939.301 127.874 939.707 127.577C940.121 127.281 940.461 126.738 940.727 125.948L941.207 124.659L936.684 112.12H939.051L942.215 121.624ZM960.145 118.601C960.145 120.531 959.703 122.085 958.82 123.265C957.938 124.445 956.742 125.034 955.234 125.034C953.695 125.034 952.484 124.546 951.602 123.57V129.675H949.434V112.12H951.414L951.52 113.527C952.402 112.433 953.629 111.886 955.199 111.886C956.723 111.886 957.926 112.46 958.809 113.609C959.699 114.757 960.145 116.355 960.145 118.402V118.601ZM957.977 118.355C957.977 116.925 957.672 115.796 957.063 114.968C956.453 114.14 955.617 113.726 954.555 113.726C953.242 113.726 952.258 114.308 951.602 115.472V121.531C952.25 122.687 953.242 123.265 954.578 123.265C955.617 123.265 956.441 122.855 957.051 122.034C957.668 121.206 957.977 119.98 957.977 118.355ZM968.172 125.034C966.453 125.034 965.055 124.472 963.977 123.347C962.898 122.214 962.359 120.702 962.359 118.812V118.413C962.359 117.156 962.598 116.034 963.074 115.05C963.559 114.058 964.23 113.284 965.09 112.73C965.957 112.167 966.895 111.886 967.902 111.886C969.551 111.886 970.832 112.429 971.746 113.515C972.66 114.601 973.117 116.156 973.117 118.179V119.081H964.527C964.559 120.331 964.922 121.343 965.617 122.116C966.32 122.882 967.211 123.265 968.289 123.265C969.055 123.265 969.703 123.109 970.234 122.796C970.766 122.484 971.23 122.07 971.629 121.554L972.953 122.585C971.891 124.218 970.297 125.034 968.172 125.034ZM967.902 113.667C967.027 113.667 966.293 113.988 965.699 114.628C965.105 115.261 964.738 116.152 964.598 117.3H970.949V117.136C970.887 116.034 970.59 115.183 970.059 114.581C969.527 113.972 968.809 113.667 967.902 113.667ZM984.52 115.214H986.148C987.172 115.198 987.977 114.929 988.563 114.406C989.148 113.882 989.441 113.175 989.441 112.284C989.441 110.284 988.445 109.284 986.453 109.284C985.516 109.284 984.766 109.554 984.203 110.093C983.648 110.624 983.371 111.331 983.371 112.214H981.203C981.203 110.863 981.695 109.741 982.68 108.851C983.672 107.952 984.93 107.503 986.453 107.503C988.063 107.503 989.324 107.929 990.238 108.781C991.152 109.632 991.609 110.816 991.609 112.331C991.609 113.073 991.367 113.792 990.883 114.488C990.406 115.183 989.754 115.702 988.926 116.046C989.863 116.343 990.586 116.835 991.094 117.523C991.609 118.21 991.867 119.05 991.867 120.042C991.867 121.573 991.367 122.788 990.367 123.687C989.367 124.585 988.066 125.034 986.465 125.034C984.863 125.034 983.559 124.601 982.551 123.734C981.551 122.866 981.051 121.722 981.051 120.3H983.23C983.23 121.198 983.523 121.917 984.109 122.456C984.695 122.995 985.48 123.265 986.465 123.265C987.512 123.265 988.313 122.991 988.867 122.445C989.422 121.898 989.699 121.113 989.699 120.089C989.699 119.097 989.395 118.335 988.785 117.804C988.176 117.273 987.297 116.999 986.148 116.984H984.52V115.214Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 378,
    width: 138,
    height: 148,
    rx: 10,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.168 445.8C90.043 445.55 89.9414 445.105 89.8633 444.464C88.8555 445.511 87.6524 446.034 86.2539 446.034C85.0039 446.034 83.9766 445.683 83.1719 444.98C82.375 444.269 81.9766 443.37 81.9766 442.284C81.9766 440.964 82.4766 439.941 83.4766 439.214C84.4844 438.48 85.8985 438.112 87.7188 438.112H89.8281V437.116C89.8281 436.359 89.6016 435.757 89.1485 435.312C88.6953 434.859 88.0274 434.632 87.1446 434.632C86.3711 434.632 85.7227 434.827 85.1992 435.218C84.6758 435.609 84.4141 436.081 84.4141 436.636H82.2344C82.2344 436.003 82.4571 435.394 82.9024 434.808C83.3555 434.214 83.9649 433.745 84.7305 433.402C85.5039 433.058 86.3516 432.886 87.2735 432.886C88.7344 432.886 89.8789 433.253 90.7071 433.987C91.5352 434.714 91.9649 435.718 91.9961 436.999V442.835C91.9961 443.999 92.1446 444.925 92.4414 445.612V445.8H90.168ZM86.5703 444.148C87.25 444.148 87.8946 443.972 88.5039 443.62C89.1133 443.269 89.5547 442.812 89.8281 442.249V439.648H88.1289C85.4727 439.648 84.1446 440.425 84.1446 441.98C84.1446 442.659 84.3711 443.191 84.8242 443.573C85.2774 443.956 85.8594 444.148 86.5703 444.148ZM94.8672 439.355C94.8672 437.409 95.3281 435.847 96.25 434.667C97.1719 433.48 98.3789 432.886 99.8711 432.886C101.355 432.886 102.531 433.394 103.398 434.409V427.8H105.566V445.8H103.574L103.469 444.441C102.602 445.503 101.395 446.034 99.8477 446.034C98.3789 446.034 97.1797 445.433 96.25 444.23C95.3281 443.027 94.8672 441.456 94.8672 439.519V439.355ZM97.0352 439.601C97.0352 441.038 97.3321 442.163 97.9258 442.976C98.5196 443.788 99.3399 444.195 100.387 444.195C101.762 444.195 102.766 443.577 103.398 442.343V436.519C102.75 435.323 101.754 434.726 100.41 434.726C99.3477 434.726 98.5196 435.136 97.9258 435.956C97.3321 436.777 97.0352 437.991 97.0352 439.601ZM66.1563 458.05V461.12H68.5235V462.796H66.1563V470.659C66.1563 471.167 66.2617 471.55 66.4727 471.808C66.6836 472.058 67.043 472.183 67.5508 472.183C67.8008 472.183 68.1446 472.136 68.5821 472.042V473.8C68.0117 473.956 67.4571 474.034 66.918 474.034C65.9492 474.034 65.2188 473.741 64.7266 473.155C64.2344 472.57 63.9883 471.737 63.9883 470.659V462.796H61.6797V461.12H63.9883V458.05H66.1563ZM75.2149 470.624L78.168 461.12H80.4883L75.3906 475.757C74.6016 477.866 73.3477 478.921 71.6289 478.921L71.2188 478.886L70.4102 478.734V476.976L70.9961 477.023C71.7305 477.023 72.3008 476.874 72.7071 476.577C73.1211 476.28 73.461 475.737 73.7266 474.948L74.2071 473.659L69.6836 461.12H72.0508L75.2149 470.624ZM93.1446 467.601C93.1446 469.53 92.7031 471.085 91.8203 472.265C90.9375 473.445 89.7422 474.034 88.2344 474.034C86.6953 474.034 85.4844 473.546 84.6016 472.57V478.675H82.4336V461.12H84.4141L84.5196 462.527C85.4024 461.433 86.6289 460.886 88.1992 460.886C89.7227 460.886 90.9258 461.46 91.8086 462.609C92.6992 463.757 93.1446 465.355 93.1446 467.402V467.601ZM90.9766 467.355C90.9766 465.925 90.6719 464.796 90.0625 463.968C89.4531 463.14 88.6172 462.726 87.5547 462.726C86.2422 462.726 85.2578 463.308 84.6016 464.472V470.53C85.25 471.687 86.2422 472.265 87.5781 472.265C88.6172 472.265 89.4414 471.855 90.0508 471.034C90.668 470.206 90.9766 468.98 90.9766 467.355ZM101.172 474.034C99.4531 474.034 98.0547 473.472 96.9766 472.347C95.8985 471.214 95.3594 469.702 95.3594 467.812V467.413C95.3594 466.155 95.5977 465.034 96.0742 464.05C96.5586 463.058 97.2305 462.284 98.0899 461.73C98.9571 461.167 99.8946 460.886 100.902 460.886C102.551 460.886 103.832 461.429 104.746 462.515C105.66 463.601 106.117 465.155 106.117 467.179V468.081H97.5274C97.5586 469.331 97.9219 470.343 98.6172 471.116C99.3203 471.882 100.211 472.265 101.289 472.265C102.055 472.265 102.703 472.109 103.234 471.796C103.766 471.484 104.23 471.07 104.629 470.554L105.953 471.585C104.891 473.218 103.297 474.034 101.172 474.034ZM100.902 462.667C100.027 462.667 99.293 462.987 98.6992 463.628C98.1055 464.261 97.7383 465.152 97.5977 466.3H103.949V466.136C103.887 465.034 103.59 464.183 103.059 463.581C102.527 462.972 101.809 462.667 100.902 462.667ZM125.547 473.8H114.367V472.241L120.273 465.679C121.148 464.687 121.75 463.882 122.078 463.265C122.414 462.64 122.582 461.995 122.582 461.331C122.582 460.441 122.313 459.71 121.773 459.14C121.234 458.57 120.516 458.284 119.617 458.284C118.539 458.284 117.699 458.593 117.098 459.21C116.504 459.82 116.207 460.671 116.207 461.765H114.039C114.039 460.195 114.543 458.925 115.551 457.956C116.566 456.987 117.922 456.503 119.617 456.503C121.203 456.503 122.457 456.921 123.379 457.757C124.301 458.585 124.762 459.691 124.762 461.073C124.762 462.753 123.691 464.753 121.551 467.073L116.98 472.03H125.547V473.8Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -4,
    y: -4,
    width: 1064,
    height: 558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 639,
    y: 168,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 533,
    y: 223,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 559,
    y: 103,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 468,
    y: 339,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 373,
    y: 416,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 317,
    y: 311,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 685,
    y: 278,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 593,
    y: 429,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 567,
    y: 334,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d",
    x: 435,
    y: 239,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d",
    x: 402,
    y: 82,
    width: 80.4056,
    height: 76.9566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d",
    x: 322,
    y: 192,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 1047,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1056,
    y1: 0.0000302124,
    x2: 0.00003569,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15FF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1056,
    y1: 550,
    x2: 0.00000732144,
    y2: -0.0000140572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0,
    y1: 550,
    x2: 1056,
    y2: -0.000074482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 0,
    y1: 0,
    x2: 1047,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1056,
    y1: 0.0000302124,
    x2: 0.00003569,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15FF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1056,
    y1: 550,
    x2: 0.00000732144,
    y2: -0.0000140572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 0,
    y1: 550,
    x2: 1056,
    y2: -0.000074482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 0,
    y1: 0,
    x2: 1047,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1056,
    y1: 0.0000302124,
    x2: 0.00003569,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15FF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 1056,
    y1: 550,
    x2: 0.00000732144,
    y2: -0.0000140572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 0,
    y1: 550,
    x2: 1056,
    y2: -0.000074482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 0,
    y1: 0,
    x2: 1047,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 1056,
    y1: 0.0000302124,
    x2: 0.00003569,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15FF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 1056,
    y1: 550,
    x2: 0.00000732144,
    y2: -0.0000140572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 0,
    y1: 550,
    x2: 1056,
    y2: -0.000074482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimationpic);
export default __webpack_public_path__ + "static/media/animationpic.30648e8353633ec011feb5381e9f6194.svg";
export { ForwardRef as ReactComponent };